import { useEffect, useState } from "react";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe, Stripe } from "@stripe/stripe-js";
import { toast } from "shared/providers/toast/toast.package";

import { Spinner } from "shared/components/spinner";

import { IStripeWrapperProps } from "./stripe-wrapper.interfaces";

const StripeWrapper = ({
  publishableKey,
  accountId,
  children,
}: IStripeWrapperProps) => {
  const [stripeObject, setStripeObject] = useState<Stripe | null>(null);
  const [stripeObjectLoaded, setStripeObjectLoaded] = useState(false);

  useEffect(
    () => {
      const fetchStripeObject = async () => {
        if (!stripeObject) {
          if (publishableKey) {
            try {
              const res = await loadStripe(publishableKey, {
                stripeAccount: accountId ?? undefined,
              });
              setStripeObject(res);
            } catch (err) {
              console.log(err);
              toast.error(
                "We had an error establishing Stripe connection. Some features might not work."
              );
            }

            setStripeObjectLoaded(true);
          }
        } else {
          toast.error(
            "We have detected that Stripe has been changed so page will now refresh to take the effect of the changes you made."
          );

          setTimeout(() => {
            window.location.reload();
          }, 2000);
        }
      };

      fetchStripeObject();
    },
    // eslint-disable-next-line
    [publishableKey]
  );

  if (publishableKey && !stripeObjectLoaded) {
    return <Spinner $height="100vh" />;
  }

  return <Elements stripe={stripeObject}>{children}</Elements>;
};

export default StripeWrapper;
